import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=57f078b4&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=ts"
export * from "./Offers.vue?vue&type=script&lang=ts"
import style0 from "./Offers.vue?vue&type=style&index=0&id=57f078b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f078b4",
  null
  
)

export default component.exports